import React from 'react'
import styled from '@emotion/styled'
import Content from 'src/components/atoms/policy/Content'

const ContentRight = ({ children }) => {
  return <ContentRightStyle>{children}</ContentRightStyle>
}

const ContentRightStyle = styled(Content)`
  text-align: right;
`
export default ContentRight
